import state from './state'
// import mutations from './mutations'
import actions from './actions'

const settings = {
  actions,
  state
}

export default settings



// WEBPACK FOOTER //
// ./src/store/plan/index.js